import { IonContent, IonPage } from '@ionic/react'

import { EmailCheckInContent } from '../../../check-in/components/email-check-in-content'

function PairedEmailCheckInPage() {
  return (
    <IonPage>
      <IonContent>
        <EmailCheckInContent />
      </IonContent>
    </IonPage>
  )
}

export { PairedEmailCheckInPage }
